import { useState } from 'react';
import "../../../styles/dialog.scss";
import {
    Box,
    DialogTitle,
    DialogContent,
    DialogActions,
    Dialog,
    IconButton,
    Drawer
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/Help';

export const DefaultFormDialog = (props: any) => {
    const [showDescription, setShowDescription] = useState<boolean>(false);

    function toggleDescription() {
        setShowDescription(!showDescription);
    }

    return (
        <>
            <Drawer
                className="drawer__node-configuration"
                open={ props.open }
                anchor="left"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: 800,
                    },
                }}
                onClose={ props.handleClose }>
                <Box className="configuration__container">
                    <Box className="container__title" >
                        <span>{ props.title }</span>
                        <Box display="flex">
                            <IconButton type="button" onClick={ toggleDescription } title="Help">
                                <HelpIcon />
                            </IconButton>
                            <IconButton onClick={ props.handleClose }>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                    <Box className="container__form">
                        { props.children }
                    </Box>
                </Box>
            </Drawer>

            <Dialog
                open={ showDescription }
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle>
                    <Box display="flex" justifyContent="space-between">
                        <span>{ props.title }</span>
                        <IconButton onClick={ toggleDescription }>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <div className="description-container">
                        <div className="description">
                            <span>{ "Description" }</span>
                            <pre>
                                { props.description }
                            </pre>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}